import { Box, Typography } from "@mui/material";
import React, { ReactNode } from "react";

interface ListCardFieldProps {
    keepLineBreaks?: boolean;
    title?: string;
    value?: string | ReactNode;
}

export const ListCardField = ({ keepLineBreaks, title, value }: ListCardFieldProps) => {
    return (
        <Box display="flex" flexDirection="column" sx={{ marginBottom: "1rem" }}>
            <Typography variant="caption" sx={{ color: "text.secondary" }}>{title}</Typography>
            {typeof value === "string"
                ? (
                    <Typography sx={{ whiteSpace: keepLineBreaks ? "pre-line" : "initial" }}>{value}</Typography>
                )
                : (value)
            }
        </Box>
    );
};
